import axios from 'axios';
import {SOFTDATAWSURL} from '../config.js'

const axiosInstance = axios.create({
    baseURL: SOFTDATAWSURL
});


export default axiosInstance;